import React from 'react';

const ProfilePage = ({ userData }) => {
    if (!userData) return <div>Loading profile...</div>;

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">User Profile</h1>
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl">
                <div className="space-y-4">
                    <div className="flex items-center">
                        <p className="w-1/3 text-gray-500">Full Name</p>
                        <p className="font-medium text-gray-800">{userData.firstName} {userData.lastName}</p>
                    </div>
                    <div className="flex items-center">
                        <p className="w-1/3 text-gray-500">Email Address</p>
                        <p className="font-medium text-gray-800">{userData.email}</p>
                    </div>
                    <div className="flex items-center">
                        <p className="w-1/3 text-gray-500">Company</p>
                        <p className="font-medium text-gray-800">{userData.companyName || 'N/A'}</p>
                    </div>
                    <div className="flex items-center">
                        <p className="w-1/3 text-gray-500">Role</p>
                        <p className="font-medium text-gray-800 capitalize">{userData.role}</p>
                    </div>
                     <div className="pt-4">
                        <h2 className="text-xl font-semibold text-gray-700 mb-2">API Keys</h2>
                        <div className="bg-gray-100 p-3 rounded-md text-sm text-gray-600 font-mono">
                            <p>sk-xxxxxxxxxxxxxxxxxxxxxx-xxxx</p>
                        </div>
                        <button className="mt-2 text-indigo-600 hover:underline text-sm">Generate New Key</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;

